var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoingWell1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 79,
    viewBox: "0 0 89 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0497 55.0995C44.3011 55.0995 55.0994 44.3252 55.0994 31.0498C55.0994 17.7983 44.3011 7 31.0497 7C17.7743 7 7 17.7983 7 31.0498C7 44.1002 17.4121 54.7336 30.3769 55.0903L31.0497 55.0995Z",
    fill: "url(#paint0_linear_112_1018)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_112_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8908 43.8762C37.9582 43.8762 43.7173 38.1299 43.7173 31.0497C43.7173 23.9823 37.9582 18.2231 30.8908 18.2231C23.8106 18.2231 18.0643 23.9823 18.0643 31.0497C18.0643 38.0099 23.6175 43.681 30.532 43.8713L30.8908 43.8762Z",
    fill: "#0062FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_112_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9658 77.2786C73.0024 77.2786 87.7001 62.6136 87.7001 44.5442C87.7001 26.5076 73.0024 11.8098 54.9658 11.8098C36.8965 11.8098 22.2315 26.5076 22.2315 44.5442C22.2315 62.3073 36.4036 76.7805 54.05 77.266L54.9658 77.2786Z",
    fill: "url(#paint1_linear_112_1018)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9594 77.744H54.9658C73.2591 77.744 88.1655 62.8709 88.1655 44.5442C88.1655 26.2505 73.2594 11.3444 54.9658 11.3444C36.6391 11.3444 21.7661 26.2508 21.7661 44.5442C21.7661 62.5601 36.1395 77.2388 54.0372 77.7313L54.0436 77.7314L54.9594 77.744Z",
    stroke: "url(#paint2_linear_112_1018)",
    strokeWidth: 0.930796,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_112_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4713 45.0783C41.4713 37.3303 47.7522 31.0493 55.5002 31.0493C63.2482 31.0493 69.5292 37.3303 69.5292 45.0783C69.5292 52.8264 63.2482 59.1074 55.5002 59.1074C47.7522 59.1074 41.4713 52.8264 41.4713 45.0783ZM51.6356 34.5382C48.5461 35.6714 46.0933 38.1242 44.9602 41.2137C45.3316 41.0539 45.7229 40.9067 46.1287 40.7714C47.3246 40.3728 48.721 40.0537 50.2528 39.8309C50.4756 38.2991 50.7947 36.9027 51.1933 35.7068C51.3286 35.301 51.4758 34.9097 51.6356 34.5382ZM59.3648 34.5382C59.5246 34.9097 59.6719 35.301 59.8071 35.7068C60.2057 36.9027 60.5249 38.299 60.7477 39.8308C62.2796 40.0536 63.676 40.3728 64.872 40.7714C65.2777 40.9067 65.6689 41.0539 66.0402 41.2136C64.9071 38.1241 62.4543 35.6714 59.3648 34.5382ZM57.8606 39.5375C57.671 38.4341 57.4279 37.4418 57.1453 36.5941C56.7917 35.5333 56.4016 34.7761 56.0366 34.3129C55.9374 34.187 55.695 33.8546 55.5002 33.8552C55.3055 33.8546 55.0631 34.187 54.9639 34.3129C54.5988 34.7761 54.2087 35.5333 53.8551 36.5941C53.5726 37.4418 53.3295 38.4341 53.1398 39.5375C54.6768 39.4442 56.3236 39.4442 57.8606 39.5375ZM61.0411 42.7179C62.1445 42.9075 63.1369 43.1506 63.9847 43.4332C65.0454 43.7868 65.8026 44.1769 66.2659 44.542C66.4046 44.6514 66.705 44.8724 66.7234 45.0756C66.7234 45.3007 66.4203 45.493 66.2659 45.6147C65.8026 45.9798 65.0454 46.3699 63.9847 46.7234C63.1369 47.006 62.1445 47.2492 61.0411 47.4388C61.1343 45.9017 61.1343 44.2549 61.0411 42.7179ZM58.2054 47.7835C58.3417 45.9844 58.3417 44.1723 58.2053 42.3732C56.4062 42.2368 54.5942 42.2369 52.7951 42.3732C52.6587 44.1723 52.6587 45.9844 52.7951 47.7835C54.5942 47.9198 56.4063 47.9198 58.2054 47.7835ZM60.7477 50.3259C62.2796 50.103 63.676 49.7839 64.872 49.3853C65.2777 49.25 65.6689 49.1028 66.0402 48.9431C64.9071 52.0325 62.4544 54.4853 59.365 55.6184C59.5247 55.247 59.6719 54.8558 59.8071 54.4501C60.2058 53.2542 60.5249 51.8578 60.7477 50.3259ZM55.5029 56.3016C55.7061 56.2833 55.9272 55.9828 56.0366 55.844C56.4016 55.3808 56.7917 54.6236 57.1453 53.5629C57.4279 52.7151 57.671 51.7227 57.8607 50.6192C56.3236 50.7125 54.6768 50.7124 53.1398 50.6192C53.3294 51.7226 53.5725 52.715 53.8551 53.5629C54.2087 54.6236 54.5988 55.3808 54.9639 55.844C55.0866 55.9998 55.2755 56.3016 55.5029 56.3016ZM51.6355 55.6184C48.546 54.4852 46.0933 52.0325 44.9602 48.943C45.3316 49.1028 45.7229 49.25 46.1287 49.3853C47.3246 49.7839 48.7209 50.103 50.2527 50.3258C50.4756 51.8577 50.7947 53.2542 51.1933 54.4501C51.3286 54.8558 51.4757 55.247 51.6355 55.6184ZM49.9594 47.4388C48.856 47.2491 47.8637 47.006 47.016 46.7234C45.9553 46.3699 45.1981 45.9798 44.7349 45.6147C44.6033 45.511 44.2176 45.2665 44.2815 45.0569C44.2962 45.0085 44.3988 44.8068 44.7349 44.542C45.1981 44.1769 45.9553 43.7868 47.016 43.4332C47.8637 43.1507 48.8561 42.9076 49.9594 42.7179C49.8661 44.2549 49.8661 45.9017 49.9594 47.4388Z",
    fill: "url(#paint3_linear_112_1018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5002 33.7584C55.4251 33.7582 55.3549 33.7895 55.296 33.8272C55.2359 33.8656 55.1785 33.9166 55.1272 33.9686C55.0402 34.0569 54.9622 34.1573 54.9117 34.2223C54.9028 34.2337 54.8948 34.244 54.8878 34.253C54.5131 34.7283 54.1187 35.4971 53.7632 36.5634C53.4788 37.4167 53.2346 38.4139 53.0443 39.5211L53.0236 39.6416L53.1457 39.6342C54.6788 39.5412 56.3216 39.5412 57.8548 39.6342L57.9768 39.6416L57.9561 39.5211C57.7658 38.4138 57.5216 37.4167 57.2372 36.5634C56.8818 35.4971 56.4873 34.7283 56.1127 34.253C56.1056 34.244 56.0976 34.2337 56.0888 34.2223C56.0382 34.1573 55.9602 34.0569 55.8732 33.9686C55.8219 33.9166 55.7646 33.8656 55.7044 33.8272C55.6456 33.7895 55.5753 33.7582 55.5002 33.7584ZM55.5002 33.7584C55.5003 33.7584 55.5004 33.7584 55.5005 33.7584L55.5002 33.8552L55.4999 33.7584C55.5 33.7584 55.5001 33.7584 55.5002 33.7584ZM53.1398 39.5375L53.1339 39.4408C53.1416 39.4403 53.1492 39.4399 53.1569 39.4394C53.1511 39.472 53.1455 39.5047 53.1398 39.5375ZM53.1398 39.5375L53.2353 39.5539C53.2366 39.5465 53.2379 39.539 53.2391 39.5316C53.206 39.5335 53.1729 39.5355 53.1398 39.5375ZM57.8606 39.5375L57.7651 39.5539C57.7639 39.5465 57.7626 39.539 57.7613 39.5316C57.7945 39.5335 57.8276 39.5355 57.8606 39.5375ZM57.8606 39.5375L57.8665 39.4408C57.8589 39.4403 57.8512 39.4398 57.8436 39.4394C57.8493 39.472 57.855 39.5047 57.8606 39.5375ZM50.0635 47.555L49.943 47.5342C48.8358 47.3439 47.8386 47.0998 46.9854 46.8154C45.919 46.4599 45.1502 46.0654 44.6749 45.6908C44.6603 45.6793 44.6403 45.6645 44.6167 45.6471C44.548 45.5963 44.4491 45.5232 44.3679 45.4455C44.3123 45.3923 44.2578 45.3308 44.2216 45.264C44.1853 45.1968 44.1626 45.1147 44.1888 45.0287L50.0635 47.555ZM50.0635 47.555L50.0561 47.4329M50.0635 47.555L50.0561 47.4329M50.0561 47.4329C49.9631 45.8998 49.9631 44.2569 50.0561 42.7238L50.0635 42.6017M50.0561 47.4329L50.0635 42.6017M50.0635 42.6017L49.943 42.6224M50.0635 42.6017L49.943 42.6224M49.943 42.6224C48.8358 42.8127 47.8386 43.0569 46.9854 43.3413C45.919 43.6968 45.1502 44.0913 44.6749 44.4659C44.3304 44.7374 44.2114 44.9542 44.1888 45.0286L49.943 42.6224ZM51.7246 34.5765L51.8135 34.3698L51.6022 34.4473C48.486 35.5902 46.0121 38.0641 44.8692 41.1803L44.7917 41.3916L44.9984 41.3027C45.3671 41.1441 45.7558 40.9979 46.1594 40.8633C47.3488 40.4669 48.7394 40.1489 50.2667 39.9267L50.3382 39.9163L50.3486 39.8448C50.5708 38.3175 50.8888 36.9269 51.2852 35.7375C51.4198 35.3339 51.566 34.9452 51.7246 34.5765ZM59.3982 34.4473L59.1869 34.3698L59.2758 34.5765C59.4344 34.9452 59.5807 35.3339 59.7152 35.7375C60.1117 36.9269 60.4296 38.3175 60.6518 39.8448L60.6622 39.9163L60.7337 39.9267C62.2611 40.1489 63.6518 40.4668 64.8413 40.8633C65.2448 40.9978 65.6334 41.1441 66.002 41.3026L66.2087 41.3915L66.1312 41.1802C64.9882 38.064 62.5144 35.5902 59.3982 34.4473ZM61.0575 42.6224L60.9369 42.6017L60.9443 42.7238C61.0374 44.2569 61.0374 45.8998 60.9444 47.4329L60.9369 47.555L61.0575 47.5343C62.1648 47.344 63.1621 47.0998 64.0153 46.8154C65.0817 46.4599 65.8505 46.0654 66.3258 45.6908C66.344 45.6765 66.3657 45.6602 66.3898 45.6421C66.4586 45.5904 66.5459 45.5247 66.6197 45.4538C66.7178 45.3594 66.8203 45.2306 66.8203 45.0756H66.8207L66.8199 45.0669C66.8134 44.9948 66.7827 44.9277 66.7451 44.8694C66.7071 44.8105 66.6583 44.7549 66.6082 44.705C66.5216 44.6188 66.4232 44.542 66.3549 44.4886C66.3445 44.4805 66.3347 44.4729 66.3258 44.4659C65.8505 44.0913 65.0817 43.6968 64.0153 43.3413C63.1621 43.0569 62.1648 42.8127 61.0575 42.6224ZM58.2127 47.8801L58.2957 47.8738L58.302 47.7908C58.4387 45.9868 58.4387 44.1699 58.3019 42.3659L58.2957 42.2829L58.2127 42.2766C56.4087 42.1399 54.5917 42.1399 52.7878 42.2766L52.7048 42.2829L52.6985 42.3659C52.5618 44.1699 52.5618 45.9868 52.6985 47.7908L52.7048 47.8738L52.7878 47.8801C54.5917 48.0168 56.4087 48.0168 58.2127 47.8801ZM60.7338 50.23L60.6623 50.2404L60.6518 50.3119C60.4297 51.8393 60.1117 53.23 59.7152 54.4195C59.5807 54.823 59.4345 55.2116 59.276 55.5801L59.187 55.7869L59.3983 55.7094C62.5145 54.5664 64.9883 52.0926 66.1312 48.9765L66.2087 48.7652L66.002 48.8541C65.6334 49.0126 65.2448 49.1589 64.8413 49.2933C63.6519 49.6898 62.2612 50.0078 60.7338 50.23ZM55.5029 56.3985V56.3988L55.5116 56.3981C55.5837 56.3916 55.6508 56.3609 55.7092 56.3233C55.7681 56.2853 55.8237 56.2365 55.8736 56.1863C55.9598 56.0998 56.0366 56.0014 56.0899 55.9331C56.0981 55.9226 56.1057 55.9129 56.1127 55.904C56.4873 55.4286 56.8818 54.6599 57.2372 53.5935C57.5217 52.7402 57.7659 51.7429 57.9562 50.6356L57.9769 50.5151L57.8548 50.5225C56.3217 50.6155 54.6788 50.6155 53.1456 50.5225L53.0236 50.5151L53.0443 50.6356C53.2346 51.7429 53.4788 52.7402 53.7632 53.5935C54.1187 54.6599 54.5131 55.4286 54.8878 55.904C54.9025 55.9227 54.9194 55.9452 54.938 55.9701C54.9895 56.0388 55.0544 56.1254 55.1242 56.1983C55.2185 56.2966 55.347 56.3985 55.5029 56.3985ZM51.6021 55.7094L51.8134 55.7869L51.7245 55.5801C51.566 55.2116 51.4197 54.823 51.2852 54.4195C50.8887 53.23 50.5708 51.8393 50.3486 50.3119L50.3382 50.2404L50.2667 50.23C48.7394 50.0078 47.3488 49.6898 46.1594 49.2933C45.7558 49.1588 45.3671 49.0125 44.9984 48.854L44.7917 48.765L44.8692 48.9763C46.0121 52.0926 48.4859 54.5664 51.6021 55.7094ZM41.5681 45.0783C41.5681 37.3838 47.8057 31.1462 55.5002 31.1462C63.1947 31.1462 69.4323 37.3838 69.4323 45.0783C69.4323 52.7729 63.1947 59.0105 55.5002 59.0105C47.8057 59.0105 41.5681 52.7729 41.5681 45.0783Z",
    stroke: "url(#paint4_linear_112_1018)",
    strokeOpacity: 0.5,
    strokeWidth: 0.19378
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_112_1018",
    x: 0.6241,
    y: 0.782913,
    width: 60.5334,
    height: 60.5335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.72012,
    result: "effect1_foregroundBlur_112_1018"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_112_1018",
    x: -1.03839,
    y: -11.4602,
    width: 112.008,
    height: 112.009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.1696
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_112_1018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_112_1018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_112_1018",
    x: 26.9377,
    y: 16.5158,
    width: 59.0628,
    height: 59.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.26676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_112_1018"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.84451,
    dy: 4.84451
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.81341
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_112_1018",
    result: "effect2_dropShadow_112_1018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_112_1018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_1018",
    x1: 31.0126,
    y1: 6.92552,
    x2: 31.0126,
    y2: 55.5548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_1018",
    x1: 54.9153,
    y1: 11.7084,
    x2: 54.9153,
    y2: 77.8983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_112_1018",
    x1: 32.653,
    y1: 19.437,
    x2: 87.6469,
    y2: 73.1192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_112_1018",
    x1: 67.5399,
    y1: 36.116,
    x2: 36.286,
    y2: 37.1351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_112_1018",
    x1: 44.4937,
    y1: 40.4614,
    x2: 68.3188,
    y2: 40.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoingWell1);
export default __webpack_public_path__ + "static/media/doing-well1.a7d4dfb2ba9959d66f8e6ec920b40105.svg";
export { ForwardRef as ReactComponent };